module.exports = __webpack_public_path__ + "img/p11.0fed6949.png";